import { Component, EventEmitter, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { lastValueFrom } from 'rxjs';
import { SourceSystemType } from '../../foundation/models/enums/source-system-type.enum';
import { BaseComponent } from '../../shared/base-components/base.component';
import { AuxRoute } from '../../shared/models/route/aux-route.model';
import { ModalSize } from '../../shared/services/modal/mvd-modal.enum';
import { MvdModalService } from '../../shared/services/modal/mvd-modal.service';
import { FleetModel } from '../../titleregistration/models/fleet.model';
import { FleetService } from '../../titleregistration/services/fleet.service';
import { FleetStatusType } from '../../vehicle/models/enums/fleet-status-type.enum';
import { FleetType } from '../../vehicle/models/enums/fleet-type.enum';
import { CreateFleetContext, CreateFleetModalComponent } from './create-fleet-modal.component';
import { IndividualDetailService } from '../detail/individual-detail.service';
import { AccessControlType } from '../../foundation/models/enums/access-control-type.enum';
import * as moment from 'moment';

@Component({
    selector: 'customer-fleet',
    templateUrl: './customer-fleet.html',
    inputs: ['customerNumber', 'customerTypeId'],
    outputs: ['fleetSelected']
})

export class CustomerFleetComponent extends BaseComponent implements OnChanges {
    public fleets: FleetModel[];
    public customerNumber: number;
    public customerTypeId: number;
    public fleetType = new FleetType();
    public fleetStatusType = new FleetStatusType();
    private sourceSystemTypes: SourceSystemType = new SourceSystemType();
    public showEdit = false;
    public showResetExpirationDate = true;
    private accessControlType: AccessControlType = new AccessControlType();

    fleetSelected: EventEmitter<number> = new EventEmitter<number>();

    constructor(
        private fleetService: FleetService,
        private _router: Router,
        public modalService: MvdModalService,
        public customerDetailservice: IndividualDetailService
    ) {
        super();
        this.displayResults = false;
    }

    ngOnInit() {
        this.showResetExpirationDate = this.auth.hasACSTransactionClaimEx(this.auth.acsTransactionClaim, this.accessControlType.CanResetFleetExpirationDate.value);
        if (this.customerNumber != null) {
            this.populateFleets(this.customerNumber);
        } else {
            this.displayResults = true;
        }
    }

    ngOnChanges() {
        if (this.displayResults) {
            if (this.customerNumber != null) {
                this.populateFleets(this.customerNumber);
            }
        }
    }

    populateFleets(customerNumberId: number) {
        this.fleetService.getFleetsByCustomerNumbers([customerNumberId])
            .subscribe(result => {
                this.fleets = result;
                if (localStorage.getItem('mvd:bu').indexOf('LECU') == -1) {
                    this.customerDetailservice.isEditCustomer(customerNumberId).subscribe(
                        res => {
                            this.showEdit = !res.result;
                            this.displayResults = !res.result;
                        }
                    );
                } else {
                    this.showEdit = true;
                    this.displayResults = true;
                }
            },
            e => console.log('error', e),
            () => {
            });
    }

    getValues(id: number, types: any): string {
        if (id !== undefined && id !== null) {
            return types.FromId(id).displayValue;
        } else {
            return '';
        }
    }

    emitFleetSelection(fleetId: number) {
        const routeBuilder = this.routeBuilderFactory.create(this.sourceSystemTypes.TitleRegistration.id);

        const auxRoutes: AuxRoute[] = new Array<AuxRoute>();
        const bodyRoute = new AuxRoute();
        bodyRoute.routeName = 'fleet-vehicle';
        bodyRoute.routeParameter = [fleetId];
        bodyRoute.outletName = 'body';
        bodyRoute.isModule = true;

        const pageHeader = new AuxRoute();
        pageHeader.routeName = 'customer-info';
        pageHeader.routeParameter = [this.customerNumber];
        pageHeader.outletName = 'pageheader';
        pageHeader.isModule = true;

        auxRoutes.push(bodyRoute);
        auxRoutes.push(pageHeader);
        const outlets = routeBuilder.buildAuxiliaryRouteCommand(auxRoutes);

        this._router.navigate(['/customer/body-pageheader', outlets]);
    }

    popupCreateFleetModal() {
        const data = new CreateFleetContext(this.customerNumber, this.customerTypeId, this.fleets);
        this.modalService.open(CreateFleetModalComponent, data, ModalSize.Medium).afterClosed()
            .pipe(filter(result => !!result))
            .subscribe(
                () => {
                    this.displayResults = false;
                    this.populateFleets(this.customerNumber);
                }
            );
    }

    public resetFleetExpirationDate(fleet: FleetModel) {
        let fleetExpirationDate = moment(fleet.expirationDate).format('MM/DD/YYYY');
        let newExpirationDate = moment(fleet.expirationDate).add(-1, 'years').format('MM/DD/YYYY');
        const message = `Are you sure you want to reset the fleet expiration date from ${fleetExpirationDate} to ${newExpirationDate}?`;
        const title = 'Reset Fleet Expiration Date';
        this.modalService.confirm().title(title).body(message)
            .okBtn('Yes').cancelBtn('No')
            .open().afterClosed()
            .pipe(filter(result => !!result))
            .subscribe(async () => {
                try {
                    let newDate = await lastValueFrom(this.fleetService.updateFleetExpirationDate(fleet.id));
                    fleet.expirationDate = newDate;
                    const message = 'The fleet expiration date has been reset.';
                    const title = 'Reset Fleet Expiration Date';
                    this.modalService.alert().title(title).body(message).okBtn('Close').open();
                } catch (err) {
                    this.handleValidationResult(err);
                }
            }, () => { });
    }
}
